import React from 'react';
import { Loader } from '@mantine/core';
import useAuth from 'hooks/useAuth';
import EmbeddedLogin from './EmbeddedLogin';

interface SecureRouteProps {
    children: React.ReactNode;
}

const SecureRoute: React.FC<SecureRouteProps> = ({ children }) => {
    const { isAuthenticated, isLoading } = useAuth();

    if (isLoading) return <Loader>Varmistetaan kirjautumista...</Loader>;
    return isAuthenticated ? <>{children}</> : <EmbeddedLogin />;
};

export default SecureRoute;
